// eslint-disable-next-line no-restricted-imports
import {
  QueryInput_ClientController_GetList_OnboardingStatuses_Items as ClientOnboardingStatusTypeApi,
  Query_ClientController_GetList_AllOf_1_List_Items_OnboardingStatus as ClientOnboardingStatusTypeApi2,
  Query_ClientController_GetAvailableStatuses_Onboarding_Items as ClientOnboardingStatusTypeApi3,
  Query_ClientController_GetById_OnboardingStatus as ClientOnboardingStatusTypeApi4,
  Query_ClientController_GetById_Onboarding_Statuses_Items_Value as ClientOnboardingStatusTypeApi5,
  Query_ClientController_GetList_AllOf_1_List_Items_Onboarding_Statuses_Items_Value as ClientOnboardingStatusTypeApi6,
  Query_UserController_GetNotifications_AllOf_1_List_Items_Payload_CurrentOnboardingStatus as ClientOnboardingStatusTypeApi7,
  Query_UserController_GetNotifications_AllOf_1_List_Items_Payload_PreviousOnboardingStatus as ClientOnboardingStatusTypeApi8,
} from 'api/generated/graphql';
import {
  ClientOnboardingStatusType,
  OnboardingStatusType,
} from 'api/types/entity';
import { Maybe } from 'types/maybe';

type Status =
  | ClientOnboardingStatusTypeApi
  | ClientOnboardingStatusTypeApi2
  | ClientOnboardingStatusTypeApi3
  | ClientOnboardingStatusTypeApi4
  | ClientOnboardingStatusTypeApi5
  | ClientOnboardingStatusTypeApi6
  | ClientOnboardingStatusTypeApi7
  | ClientOnboardingStatusTypeApi8;

const statusMap: Record<Status, ClientOnboardingStatusType> = {
  [ClientOnboardingStatusTypeApi.FillingOut]: OnboardingStatusType.FillingOut,
  [ClientOnboardingStatusTypeApi.AccountOpened]:
    OnboardingStatusType.AccountOpened,
  [ClientOnboardingStatusTypeApi.ComplianceCheck]:
    OnboardingStatusType.ComplianceCheck,
  [ClientOnboardingStatusTypeApi.AccountOpeningDenied]:
    OnboardingStatusType.AccountOpeningDenied,
  [ClientOnboardingStatusTypeApi.AmlCftCheck]: OnboardingStatusType.AmlCftCheck,
  [ClientOnboardingStatusTypeApi.AccountOpening]:
    OnboardingStatusType.AccountOpening,
  [ClientOnboardingStatusTypeApi.AwaitingAccountOpening]:
    OnboardingStatusType.AwaitingAccountOpening,
  [ClientOnboardingStatusTypeApi.AwaitingAmlCftCheck]:
    OnboardingStatusType.AwaitingAmlCftCheck,
  [ClientOnboardingStatusTypeApi.AwaitingComplianceCheck]:
    OnboardingStatusType.AwaitingComplianceCheck,
  [ClientOnboardingStatusTypeApi.AwaitingValidation]:
    OnboardingStatusType.AwaitingValidation,
  [ClientOnboardingStatusTypeApi.BoardReview]: OnboardingStatusType.BoardReview,
  [ClientOnboardingStatusTypeApi.ValidationCheck]:
    OnboardingStatusType.ValidationCheck,
  [ClientOnboardingStatusTypeApi.PendingBoardReview]:
    OnboardingStatusType.PendingBoardReview,
  [ClientOnboardingStatusTypeApi.SigningDocuments]:
    OnboardingStatusType.SigningDocuments,
  [ClientOnboardingStatusTypeApi.AwaitingPaymentConfirmation]:
    OnboardingStatusType.AwaitingPaymentConfirmation,
  [ClientOnboardingStatusTypeApi.SigningQuestionnaire]:
    OnboardingStatusType.SigningQuestionnaire,
};

export const parseClientOnboardingStatus = (
  status: Maybe<Status>
): ClientOnboardingStatusType =>
  status ? statusMap[status] : OnboardingStatusType.FillingOut;
